import React, { useContext } from 'react'
import { ReducerDispatchContext, ReducerContext } from '../reducers/reducerContext.js';
import helperCriteriaCalculator from '../helpers/HelperCriteriaCalculator.js';
import {
    fetchSimulationVehicleDetailsIfNeededCalculator, fetchServiceLevelsIfNeeded, fetchCriteriaOnParameterChangeIfNeeded
} from '../actions/actionsApiOffer.js'
import {
    setCalculatorCriteriaDuration, setCalculatorCriteriaMileage, setCalculatorCriteriaDeposit, setCalculatorCriteriaSvcMap,
    setCalculatorCriteriaProduct, setCalculatorCriteriaCustomer, selectCalculatorBenefit, selectServiceInformation
} from '../actions/actionsAppCalculator.js'
import CalculatorCriteriaSvcLevels from '../components/calculator/CalculatorCriteriaSvcLevels.js';

export default function ContCalculatorCriteriaSvcLevels(props) {
    const dispatch = useContext(ReducerDispatchContext);
    const globalstate = useContext(ReducerContext);

    function onChangeProduct(productKey) {
        dispatch(setCalculatorCriteriaProduct(productKey));
        fetchServiceLevelsIfNeeded(globalstate, dispatch, productKey);
    }
    function onChangeDeposit(deposit, settings) {
        dispatch(setCalculatorCriteriaDeposit(deposit));
        fetchCriteriaOnParameterChangeIfNeeded(globalstate, dispatch, 'deposit', deposit);
        fetchSimulationVehicleDetailsIfNeededCalculator(globalstate, dispatch, 'deposit', deposit, settings);
    }
    function onChangeDuration(duration, settings) {
        dispatch(setCalculatorCriteriaDuration(duration));
        fetchCriteriaOnParameterChangeIfNeeded(globalstate, dispatch, 'duration', duration);
        fetchSimulationVehicleDetailsIfNeededCalculator(globalstate, dispatch, 'duration', duration, settings);
    }
    function onChangeMileage(mileage, settings) {
        dispatch(setCalculatorCriteriaMileage(mileage));
        fetchCriteriaOnParameterChangeIfNeeded(globalstate, dispatch, 'annualMileage', mileage);
        fetchSimulationVehicleDetailsIfNeededCalculator(globalstate, dispatch, 'annualMileage', mileage, settings);
    }
    function onChangeService(svcMap, settings) {
        dispatch(setCalculatorCriteriaSvcMap(svcMap));
        const serviceParameters = helperCriteriaCalculator.getServiceParameters(svcMap);
        fetchCriteriaOnParameterChangeIfNeeded(globalstate, dispatch, 'services', serviceParameters);
        fetchSimulationVehicleDetailsIfNeededCalculator(globalstate, dispatch, 'services', serviceParameters, settings);
    }
    function onChangeCustomer(customer, settings) {
        dispatch(setCalculatorCriteriaCustomer(customer));
        fetchSimulationVehicleDetailsIfNeededCalculator(globalstate, dispatch, 'customer', customer, settings);
    }
    function onSelectBenefit(benefit) {
        dispatch(selectCalculatorBenefit(benefit));
    }
    function onCloseBenefit() {
        dispatch(selectCalculatorBenefit({}));
    }
    function onSelectServiceInformation(serviceInformation) {
        dispatch(selectServiceInformation(serviceInformation));
    }
    function onCloseServiceInformation() {
        dispatch(selectServiceInformation({}));
    }

    return (
        <CalculatorCriteriaSvcLevels
            onChangeProduct={onChangeProduct}
            onChangeDuration={onChangeDuration}
            onChangeMileage={onChangeMileage}
            onChangeDeposit={onChangeDeposit}
            onChangeService={onChangeService}
            onChangeCustomer={onChangeCustomer}
            onSelectBenefit={onSelectBenefit}
            onCloseBenefit={onCloseBenefit}
            onSelectServiceInformation={onSelectServiceInformation}
            onCloseServiceInformation={onCloseServiceInformation}
            onUpdate={props.onUpdate}
            isCalculationResult={props.isCalculationResult}
            calculationResponse={props.calculationResponse}
            context={globalstate.testCriteria.context}
            settings={globalstate.settings}
            parameters={globalstate.calculator.parameters}
            contextCriteria={globalstate.calculator.contextCriteria}
            svcMap={globalstate.calculator.svcMap}
            benefit={globalstate.calculator.benefit}
            serviceInformation={globalstate.calculator.serviceInformation}
            svcLevelFiltered={globalstate.calculator.svcLevelFiltered}
            responseCriteria={globalstate.calculator.responseCriteria}
            responseOffers={globalstate.calculator.responseOffers}
        />
    );
}
